var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 9.6 16.4 L 8.498 15.3642 C 4.584 11.6994 2 9.2746 2 6.3161 C 2 3.8912 3.8392 2 6.18 2 C 7.5024 2 8.7716 2.6356 9.6 3.6323 C 10.4284 2.6356 11.6976 2 13.02 2 C 15.3608 2 17.2 3.8912 17.2 6.3161 C 17.2 9.2746 14.616 11.6994 10.702 15.3642 L 9.6 16.4 Z",
    stroke: "#A9A9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.fe400ec2e9b7228acb43ab5145946308.svg";
export { ForwardRef as ReactComponent };